import {
  SET_ACTIVE_ASSET
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_ASSET:
      return action.payload;

    default:
      return state;
  }
}